import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export const useUserClasses = () => {
  return useQuery({
    queryKey: ["my-classes"],
    queryFn: async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) throw new Error("User not authenticated");

      const { data: subscriptions, error: subsError } = await supabase
        .from("class_subscriptions")
        .select(`
          class_id,
          classes (
            id,
            title,
            description,
            instructor,
            schedule,
            capacity,
            duration,
            image_url,
            subscriptions:class_subscriptions(count)
          )
        `)
        .eq('user_id', user.id);

      if (subsError) throw subsError;
      
      return subscriptions.map(sub => ({
        ...sub.classes,
        enrolledCount: sub.classes.subscriptions[0]?.count || 0
      }));
    },
  });
};